<template>
  <dialog-card :title="title" :actions="actions" :handler="handlerClick" ref="card">
    <v-card-text class="py-0">
      <v-textarea
        ref="input"
        v-model="editedValue"
        :label="label"
        :placeholder="placeholder"
        rows="6"
        auto-grow
        hide-details="true"
        @keydown.meta.enter.exact.prevent="onSubmit"
        @keydown.ctrl.enter.exact.prevent="onSubmit" />
    </v-card-text>
  </dialog-card>
</template>

<script>
export default {
  name: 'EditTextDialog',

  props: {
    title: {
      type: String,
      default: 'Edycja tekstu'
    },
    label: {
      type: String,
      default: 'Treść'
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      actions: {
        false: 'Anuluj',
        true: {
          color: 'success',
          text: 'Zapisz'
        }
      },
      editedValue: ''
    }
  },

  beforeMount() {
    this.editedValue = this.value || ''
  },

  mounted() {
    setTimeout(() => {
      this.$refs.input.focus()
    }, 100)
  },

  methods: {
    onSubmit() {
      this.$refs.card.$refs.actions.trigger(true)
    },

    handlerClick(res, action) {
      this.$emit('submit', action.key ? this.editedValue : action.key)
    }
  }
}
</script>